import * as t from  './actionTypes';
import * as api from './api';

export function loadSeason() {

    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.getSeason((success, season, error) => {
            if (success) {
                dispatch({ type: t.SEASON_LOAD_SUCCESS, season: season || {} });
                dispatch({ type: t.UNSET_BUSY });
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
            }
        });
    }
}

export function createNewSeason(data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.createNewSeason(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.SEASON_CREATE_SUCCESS, season: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function editSeason(id, data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.editSeason(id, data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.SEASON_EDIT_SUCCESS, id: id, season: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function deleteSeason(id, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.deleteSeason(id, function(success, error) {
            if (success) {
                dispatch({ type: t.SEASON_DELETE_SUCCESS, id: id });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}
